export const REVIEW_TYPES = {
  OCF_INITIAL: "OCF_INITIAL",
  OCF_SUBSEQUENT: "OCF_SUBSEQUENT",
  PP_REGISTRATION: "PP_REGISTRATION",
  PP_ANNUAL: "PP_ANNUAL",
  CDM_REGISTRATION: "CDM_REGISTRATION",
  CDM_INTERIM: "CDM_INTERIM",
  CDM_ANNUAL: "CDM_ANNUAL",
};

// The three programmes, in the order they are presented across the CDM feature.
export const PROGRAMMES = ["OCF", "PP", "CDM"];

export const PROGRAMME_LABELS = {
  OCF: "Opportunistic Case Finding",
  PP: "Prevention Programme",
  CDM: "Chronic Disease Management",
};

export const REVIEW_TYPE_TITLES = {
  OCF_INITIAL: "OCF Initial",
  OCF_SUBSEQUENT: "OCF Subsequent",
  PP_REGISTRATION: "PP Registration",
  PP_ANNUAL: "PP Annual Review",
  CDM_REGISTRATION: "CDM Registration",
  CDM_INTERIM: "CDM Interim Review",
  CDM_ANNUAL: "CDM Annual Review",
  DEREGISTRATION: "Deregistration",
};

export const REVIEW_TYPE_TO_BUCKET = {
  CDM_REGISTRATION: "reg",
  CDM_INTERIM: "interim",
  CDM_ANNUAL: "annual",
  PP_REGISTRATION: "reg",
  PP_ANNUAL: "annual",
};

export const isDeregistration = (reviewType) =>
  reviewType === "DEREGISTRATION";
export const isCdm = (reviewType) => reviewType?.startsWith("CDM_");
export const isOcf = (reviewType) => reviewType?.startsWith("OCF_");
export const isPp = (reviewType) => reviewType?.startsWith("PP_");
export const isAnnual = (reviewType) => reviewType?.endsWith("_ANNUAL");
export const isInterim = (reviewType) => reviewType?.endsWith("_INTERIM");

// The first/registration review of a programme: CDM_REGISTRATION,
// PP_REGISTRATION or OCF_INITIAL. Only this review may be cancelled (and only
// when it has no subsequent reviews) — an interim/annual/subsequent review can
// never be cancelled.
export const isRegistration = (reviewType) =>
  reviewType?.endsWith("_REGISTRATION") ||
  reviewType === REVIEW_TYPES.OCF_INITIAL;

export const getReviewTypeTitle = (reviewType) =>
  REVIEW_TYPE_TITLES[reviewType] ?? reviewType;

export const getReviewTypeBucket = (reviewType) =>
  REVIEW_TYPE_TO_BUCKET[reviewType] ?? "reg";
